// material-ui

import adrCertificate from '../../../assets/images/qualifications/adr-certificate.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const ADRCertificate = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={adrCertificate} alt="ADRCertificate" height={props.height || 24}  />
    );
};

export default ADRCertificate;